import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import { GET_CURRENT_POLICY } from './graphql/queries';

export const VIEW_ORGANISATION_JOBS = 'VIEW_ORGANISATION_JOBS';
export const ASSIGN_ORGANISATION_WEPLOYER_ROLE = 'ASSIGN_ORGANISATION_WEPLOYER_ROLE';
export const TRANSFER_ORGANISATION_JOBS = 'TRANSFER_ORGANISATION_JOBS';
export const APPROVE_ORGANISATION_TIMESHEET = 'APPROVE_ORGANISATION_TIMESHEET';
export const VIEW_ORGANISATION_TIMESHEETS = 'VIEW_ORGANISATION_TIMESHEETS';
export const UPDATE_ORGANISATION_BILLING_ACCOUNT = 'UPDATE_ORGANISATION_BILLING_ACCOUNT';

export const PolicyContext = React.createContext();

export const nullPolicy = {
  organisationId: null,
  weployerId: null,
  role: null,
  actions: [],
};

export const PolicyProvider = ({ children, onFetchSuccess }) => {
  const { data } = useQuery(GET_CURRENT_POLICY, {
    pollInterval: 30000,
  });

  const policy = (isEmpty(data) || data.errors) ? nullPolicy : data.weployer.policy;

  if (policy.role) {
    onFetchSuccess(policy);
  }

  return (
    <PolicyContext.Provider value={policy}>
      {children}
    </PolicyContext.Provider>
  );
};

PolicyProvider.propTypes = {
  children: PropTypes.object.isRequired,
  onFetchSuccess: PropTypes.func,
};

PolicyProvider.defaultProps = {
  onFetchSuccess: () => {},
};
